import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

function mountApp() {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// On a directly loaded prerendered product page, leave the already-visible
// static HTML in place until its React route chunk has been downloaded.
// Otherwise React's Suspense fallback may replace a complete product page
// with a brief "Loading..." screen. This is NOT React hydration.
const hasPublicSnapshot = Boolean(document.getElementById('pa-prerender-data'));
const isProductPage = /^\/products\/[a-z0-9_-]+\/?$/i.test(window.location.pathname);

if (hasPublicSnapshot && isProductPage) {
  import('./pages/Product/ProductPage').then(mountApp, mountApp);
} else {
  mountApp();
}

reportWebVitals();
